import { FeedbackRptService } from '../services';
import { FeedbackRptConstants } from '../constants';
import { alertActions } from '.';

export const FeedbackRptActions = {
    getAll,
    loadingData,
    exportData,
    exportDataExtraBenefit,
    getAllExtraBenfit,
    GetDealerPaymentTransfer,
    DealerAvStockReport,
    exportDealerAvStockReport,
    exportDealerPaymentTransfer,
    getAllExtraBenfitRedeemPoint,
    getReturnReport,
    getPassbookReport,
    getPrinterReport

};

function getAll(obj) {
    return dispatch => {
        dispatch(request());
        FeedbackRptService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALL_FAILURE, error } }
}



function getAllExtraBenfit(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.fetchExtraBenefitData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}


function getReturnReport(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.getRetrunReport(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}

function getPassbookReport(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.getPassbookReport(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}

function getPrinterReport(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.getPrinterReport(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}
function getAllExtraBenfitRedeemPoint(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.getAllExtraBenfitRedeemPoint(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}


function exportData(obj) {
    return dispatch => {
        dispatch(request());
        FeedbackRptService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}

function exportDataExtraBenefit(obj) {
    return dispatch => {
        dispatch(request());
        FeedbackRptService.fetchExtraBenefitData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}

function exportDealerAvStockReport(obj) {
    return dispatch => {
        dispatch(request());

        FeedbackRptService.GetDealerAvStockReport(obj).then(
            response => {
                dispatch(loadingData(false));
                let data = response.ResponseData;               
                if (!Array.isArray(data)) {
                    data = [];
                }              
                data.forEach(v => delete v.TotalRows);            
                dispatch(success(data));
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}


function loadingData(isbool) {
    return {
        type: FeedbackRptConstants.LOADING_REQUEST, isbool
    }
}

function GetDealerPaymentTransfer(obj) {
    
    return dispatch => {
        dispatch(request());
        FeedbackRptService.GetDealerPaymentTransfer(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}

function DealerAvStockReport(obj) {
    return dispatch => {
        dispatch(request());

        FeedbackRptService.GetDealerAvStockReport(obj).then(
            response => {
                dispatch(loadingData(false));

                const rawData = response?.ResponseData;
                const data = Array.isArray(rawData) ? [...rawData] : [];

                dispatch(success(data));              
                const exportData = data.map(({ TotalRows, ...rest }) => rest);            
                dispatch(successExport(exportData));
            },
            error => {
                dispatch(loadingData(false));
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function request() { return { type: FeedbackRptConstants.GETALLEX_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALLEX_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORTEX_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALLEX_FAILURE, error } }
}

function exportDealerPaymentTransfer(obj) {
    return dispatch => {
        dispatch(request());
        FeedbackRptService.GetDealerPaymentTransfer(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}
